export default {
  title: 'SeedOut Fenua logo navbar',
  img: './img/navbar/logo_fenua.webp',
  alt: 'SeedOut Fenua logo navbar'
}
